(function ($) {
    'use strict';

    var DEFAULT_TEXT = 'will support us in striving for a world where every working animal lives a life free from suffering and is treated with compassion.';
    var DONATE_BASE_URL = 'https://donate.workinganimals.org/';

    const allowedDomains = ["dev-spana-v2.pantheonsite.io", "test-spana-v2.pantheonsite.io", "dev.workinganimals.org"];

    if (allowedDomains.includes(window.location.hostname)) {
        var DONATE_BASE_URL = 'https://staging-donate.workinganimals.org/';
    } else {
        var DONATE_BASE_URL = 'https://donate.workinganimals.org/';
    }


    function initDonationBanner($root) {

        var $currency = $root.find('[data-donation-currency]');
        var $amounts = $root.find('[data-donation-amounts]');
        var $typeButtons = $root.find('[data-donation-type]');
        var $customAmount = $root.find('[data-donation-custom-amount]');
        var $error = $root.find('[data-donation-error]');
        var $submit = $root.find('[data-donation-submit]');
        var $description = $root.find('[data-donation-description]');
        var $allowBadge = $root.data('allowbadge');


        // hide custom amount field container initially
        var $customContainer = $customAmount.closest('div');
        if ($customContainer.length) {
            $customContainer.hide();
        }

        if (!$currency.length || !$amounts.length || !$typeButtons.length || !$submit.length || !$description.length) {
            return;
        }

        var state = {
            loadedOptions: false,
            minimumAmountIsMet: true,
            options: {},
            region: 'gbp',
            utmParams: {},
            donationTypePreference: {
                GBP: 'Single',
                AUD: 'Single'
            },
            preselectedAmount: {
                Single: { GBP: '', AUD: '' },
                Monthly: { GBP: '', AUD: '' }
            },
            selected: {
                currency: 'GBP',
                donationType: 'Single',
                amount: '',
                amountIndex: -1,
                otherAmount: ''
            }
        };

        function amountToNumber(amount) {
            var value = parseFloat(amount);
            return Number.isNaN(value) ? 0 : value;
        }

        function amountEquals(a, b) {
            return amountToNumber(a) === amountToNumber(b);
        }

        function getSymbol(currency) {
            return currency === 'AUD' ? '$' : '\u00A3';
        }

        function getMinimumAmount() {
            //return state.selected.donationType === 'Monthly' ? 2 : 1;
            return state.selected.donationType === 'Monthly' ? 1 : 1;
        }

        function getRegionKey(currency) {
            return (currency === 'AUD' ? 'aus' : 'gbp') + '_options';
        }

        function getPaymentsKey(donationType) {
            return donationType === 'Monthly' ? 'monthly_payments' : 'single_payments';
        }

        function getJourney() {
            return state.options[getRegionKey(state.selected.currency)] || {};
        }

        function getJourneyPayments() {
            var journey = getJourney();
            return journey[getPaymentsKey(state.selected.donationType)] || [];
        }

        function sanitizeCustomAmount(value) {
            var digitsOnly = String(value || '').replace(/\D/g, '').slice(0, 5);
            var normalized = digitsOnly.replace(/^0+/, '');

            return normalized === '0' ? '' : normalized;
        }

        function pickDefaultAmount(payments, configuredDefault) {
            var matched = payments.find(function (payment) {
                return amountEquals(payment.amount, configuredDefault);
            });

            if (matched) {
                return String(matched.amount);
            }

            if (payments[1] && payments[1].amount !== undefined) {
                return String(payments[1].amount);
            }

            if (payments[0] && payments[0].amount !== undefined) {
                return String(payments[0].amount);
            }

            return '';
        }

        function saveUtmParamsToStorage(utmParams) {
            if (!Object.keys(utmParams).length) {
                return;
            }

            try {
                sessionStorage.setItem('spana_utm_params', JSON.stringify(utmParams));
            } catch (error) {
                console.error('Failed to save UTM params to sessionStorage:', error);
            }
        }

        function getUtmParamsFromStorage() {
            try {
                var stored = sessionStorage.getItem('spana_utm_params');
                return stored ? JSON.parse(stored) : null;
            } catch (error) {
                console.error('Failed to retrieve UTM params from sessionStorage:', error);
                return null;
            }
        }

        function getUtmParams() {
            var params = new URLSearchParams(window.location.search);
            var utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
            var utmParams = {};
            var hasUtmInUrl = false;

            utmKeys.forEach(function (key) {
                if (params.has(key)) {
                    utmParams[key] = params.get(key);
                    hasUtmInUrl = true;
                }
            });

            if (hasUtmInUrl) {
                saveUtmParamsToStorage(utmParams);
                return utmParams;
            }

            return getUtmParamsFromStorage() || {};
        }

        function updateTypeUI() {
            $typeButtons.each(function () {
                var $button = jQuery(this);
                var isSelected = $button.data('donation-type') === state.selected.donationType;

                if (isSelected) {
                    $button.removeClass('bg-[#F8F4E4] text-[#513937]').addClass('bg-[#513937] text-white');
                } else {
                    $button.removeClass('bg-[#513937] text-white').addClass('bg-[#F8F4E4] text-[#513937]');
                }
            });
        }

        function updateAmountUI() {
            $amounts.find('[data-donation-amount]').each(function () {
                var $button = jQuery(this);
                var value = $button.data('amount-value');
                var isSelected = amountEquals(value, state.selected.amount);
                if (isSelected) {
                    $button.removeClass('bg-[#F8F4E4] text-[#513937]').addClass('bg-[#513937] text-white');
                } else {
                    $button.removeClass('bg-[#513937] text-white').addClass('bg-[#F8F4E4] text-[#513937]');
                }
            });

            var $other = $amounts.find('[data-donation-other]');
            if (state.selected.otherAmount !== '') {
                $other.removeClass('bg-[#F8F4E4] text-[#513937]').addClass('bg-[#513937] text-white');
            } else {
                $other.removeClass('bg-[#513937] text-white').addClass('bg-[#F8F4E4] text-[#513937]');
            }
        }

        function updateDescription() {
            if (!state.selected.amount || state.selected.otherAmount !== '') {
                var defaultText = state.options.default_donation_text || DEFAULT_TEXT;
                $description.html(defaultText);
                return;
            }

            var payments = getJourneyPayments();
            var selectedPayment = payments[state.selected.amountIndex];

            if (!selectedPayment) {
                selectedPayment = payments.find(function (payment) {
                    return amountEquals(payment.amount, state.selected.amount);
                });
            }

            if (!selectedPayment || !selectedPayment.text) {
                var fallbackText = state.options.default_donation_text || DEFAULT_TEXT;
                $description.html(fallbackText);
                return;
            }

            $description.html('Your <strong>' + getSymbol(state.selected.currency) + state.selected.amount + '</strong> ' + selectedPayment.text);
        }

        function validateMinimumAmount() {
            var min = getMinimumAmount();
            var amount = amountToNumber(state.selected.amount);
            state.minimumAmountIsMet = amount >= min;

            if (!state.minimumAmountIsMet) {
                $error.text('Minimum donation is ' + getSymbol(state.selected.currency) + min).removeClass('hidden');
            } else {
                $error.addClass('hidden').text('');
            }

            return state.minimumAmountIsMet;
        }

        function updateSubmitText() {
            var amount = amountToNumber(state.selected.amount);
            if (amount > 0) {
                var suffix = state.selected.donationType === 'Monthly' ? ' Monthly' : ' Now';
                $submit.text('Donate ' + getSymbol(state.selected.currency) + state.selected.amount + suffix);
            } else {
                $submit.text('Donate Now');
            }
        }

        function updateUI() {
            updateTypeUI();
            updateAmountUI();
            updateDescription();
            updateSubmitText();
            //validateMinimumAmount();
        }

        function setAmountByIndex(index) {
            var payments = getJourneyPayments();
            var payment = payments[index];

            if (!payment || payment.amount === undefined) {
                return;
            }

            state.selected.amount = String(payment.amount);
            state.selected.amountIndex = index;
            state.selected.otherAmount = '';
            $customAmount.val('');
            // hide custom amount when a preset is chosen
            if ($customContainer.length) {
                $customContainer.hide();
            }
            updateUI();
        }

        function setDefaultsForCurrentSelection() {
            var preselected = state.preselectedAmount[state.selected.donationType][state.selected.currency];
            var payments = getJourneyPayments();

            state.selected.amount = preselected;
            state.selected.otherAmount = '';

            state.selected.amountIndex = payments.findIndex(function (payment) {
                return amountEquals(payment.amount, preselected);
            });

            if (state.selected.amountIndex < 0 && payments[0] && payments[0].amount !== undefined) {
                state.selected.amountIndex = 0;
                state.selected.amount = String(payments[0].amount);
            }

            $customAmount.val('');
        }

        function renderAmountButtons() {
            var payments = getJourneyPayments();
            var symbol = getSymbol(state.selected.currency);

            $amounts.empty();

            payments.forEach(function (payment, index) {
                if (payment.amount === undefined || payment.amount === null || payment.amount === '') {
                    return;
                }

                var $button = jQuery('<button/>', {
                    type: 'button',
                    class: 'w-full rounded-full py-2 px-2 md:px-3 lg:px-5 text-lg font-black text-[#513937] bg-[#F8F4E4] hover:bg-[#513937] hover:text-white transition cursor-pointer',
                    text: symbol + payment.amount
                });

                $button.attr('data-donation-amount', '1');
                $button.attr('data-amount-index', index);
                $button.attr('data-amount-value', payment.amount);
                $button.on('click', function () {
                    setAmountByIndex(index);
                });

                $amounts.append($button);
            });

            var $otherButton = jQuery('<button/>', {
                type: 'button',
                class: 'w-full rounded-full py-2 px-2 md:px-3 lg:px-5 text-lg font-black text-[#513937] bg-[#F8F4E4] hover:bg-[#513937] hover:text-white transition cursor-pointer',
                text: 'Other'
            });

            $otherButton.attr('data-donation-other', '1');
            $otherButton.on('click', function () {
                state.selected.amount = '';
                state.selected.amountIndex = -1;
                // reveal the custom amount field when Other is selected
                if ($customContainer.length) {
                    $customContainer.show();
                }
                $customAmount.trigger('focus');
                updateUI();
            });

            $amounts.append($otherButton);

            // If no preset amounts exist, auto-select "Other" and open the custom input
            var hasPresetAmounts = $amounts.find('[data-donation-amount]').length > 0;
            if (!hasPresetAmounts) {
                state.selected.amount = '';
                state.selected.amountIndex = -1;
                state.selected.otherAmount = '';
                $otherButton.hide();
                if ($customContainer.length) {
                    $customContainer.show();
                }
            }
        }

        function onCurrencyChange(currency) {
            state.selected.currency = currency;
            state.region = currency === 'AUD' ? 'aus' : 'gbp';
            state.selected.donationType = state.donationTypePreference[currency] || 'Single';

            setDefaultsForCurrentSelection();
            renderAmountButtons();
            updateUI();
        }

        function onDonationTypeChange(type) {
            state.selected.donationType = type;
            setDefaultsForCurrentSelection();
            renderAmountButtons();
            updateUI();
        }

        function onCustomAmountChange(value) {
            var sanitized = sanitizeCustomAmount(value);
            if (sanitized !== value) {
                $customAmount.val(sanitized);
            }

            state.selected.otherAmount = sanitized;
            state.selected.amount = sanitized;

            if (amountToNumber(state.selected.amount) >= 2) {
                state.minimumAmountIsMet = true;
            }

            updateUI();
        }

        function buildDonateUrl() {
            var route = 'details';
            var currencyPath = state.selected.currency === 'GBP' ? 'gbr' : 'aus';

            if (state.selected.currency === 'GBP' && state.selected.donationType === 'Monthly') {
                route = 'pre-step';
            }

            var journey = getJourney();
            var appealCode = journey.appeal_code || 'generaldonation';

            var basePath = currencyPath + '/' + state.selected.donationType + '/' + appealCode + '/' + state.selected.amount + '/' + route + '/';

            var queryParams = [];

            // Add UTM parameters
            if (Object.keys(state.utmParams).length > 0) {
                Object.entries(state.utmParams).forEach(function (entry) {
                    queryParams.push(entry[0] + '=' + encodeURIComponent(entry[1]));
                });
            }

            // Add badge parameter if $allowBadge has value "Yes"
            var badgeValue = $allowBadge ? $allowBadge : null;

            if (badgeValue === 'Yes') {
                queryParams.push('badge=show');
            }

            var queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : '';
            return DONATE_BASE_URL + basePath + queryString;
        }

        function fetchDonationOptions(pageId) {
            return $.ajax({
                url: '?get_donation_form_options_from_api=' + pageId + '&token=true',
                method: 'GET'
            });
        }

        function hydrateFromOptions(options) {
            state.options = options || {};

            var gbpOptions = options.gbp_options || {};
            var ausOptions = options.aus_options || {};

            // Check which currencies have any payment data
            var gbpHasData = (gbpOptions.single_payments && gbpOptions.single_payments.length > 0) ||
                (gbpOptions.monthly_payments && gbpOptions.monthly_payments.length > 0);
            var ausHasData = (ausOptions.single_payments && ausOptions.single_payments.length > 0) ||
                (ausOptions.monthly_payments && ausOptions.monthly_payments.length > 0);

            // If no currency has data at all, hide the entire donation section
            if (!gbpHasData && !ausHasData) {
                $root.hide();
                return;
            }

            // Remove currency options that have no data
            $currency.find('option').each(function () {
                var val = jQuery(this).val();
                if ((val === 'GBP' && !gbpHasData) || (val === 'AUD' && !ausHasData)) {
                    jQuery(this).remove();
                }
            });

            // Default to a currency that actually has data
            var preferredCurrency = options.site_id === 1 ? 'GBP' : 'AUD';
            if (preferredCurrency === 'GBP' && !gbpHasData) {
                preferredCurrency = 'AUD';
            } else if (preferredCurrency === 'AUD' && !ausHasData) {
                preferredCurrency = 'GBP';
            }

            state.selected.currency = preferredCurrency;
            state.region = state.selected.currency === 'AUD' ? 'aus' : 'gbp';

            state.donationTypePreference.GBP = gbpOptions.gbp_preference || 'Single';
            state.donationTypePreference.AUD = ausOptions.aus_preference || 'Single';

            state.preselectedAmount.Single.GBP = pickDefaultAmount(gbpOptions.single_payments || [], gbpOptions.gbp_single_default);
            state.preselectedAmount.Single.AUD = pickDefaultAmount(ausOptions.single_payments || [], ausOptions.aus_single_default);
            state.preselectedAmount.Monthly.GBP = pickDefaultAmount(gbpOptions.monthly_payments || [], gbpOptions.gbp_monthly_default);
            state.preselectedAmount.Monthly.AUD = pickDefaultAmount(ausOptions.monthly_payments || [], ausOptions.aus_monthly_default);

            state.selected.donationType = state.donationTypePreference[state.selected.currency] || 'Single';

            $currency.val(state.selected.currency);

            if (typeof window.show_currency_drop_down !== 'undefined' && !window.show_currency_drop_down) {
                $currency.hide();
            }

            setDefaultsForCurrentSelection();
            renderAmountButtons();
            state.loadedOptions = true;
            updateUI();
        }

        function bindEvents() {
            $customAmount.attr('maxlength', 5);

            $currency.on('change', function () {
                onCurrencyChange(jQuery(this).val());
            });

            $typeButtons.on('click', function (event) {
                event.preventDefault();
                onDonationTypeChange(jQuery(this).data('donation-type'));
            });

            $customAmount.on('input', function () {
                onCustomAmountChange(jQuery(this).val());
            });

            $submit.on('click', function () {
                if (!validateMinimumAmount()) {
                    return;
                }

                var donateUrl = buildDonateUrl();
                window.location.href = donateUrl;
            });
        }

        function bootstrap() {
            state.utmParams = getUtmParams();
            bindEvents();

            var pageId = parseInt($root.data('page-id'), 10) || parseInt(window.page_id, 10);
            if (!pageId) {
                console.error('Donation banner: page id not found.');
                return;
            }

            fetchDonationOptions(pageId)
                .done(function (options) {
                    hydrateFromOptions(options);
                })
                .fail(function (error) {
                    console.error('Donation banner: failed to load donation options.', error);
                });
        }

        bootstrap();
    }

    jQuery(function () {
        jQuery('[data-donation-banner]').each(function () {
            initDonationBanner(jQuery(this));
        });
    });
})(jQuery);

